<template>
  <Layout
    title="Профиль ребёнка"
  >
    <template v-slot:buttons>
      <v-tooltip>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            @click="exportDialogShow = true"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>{{ mdiExport }}</v-icon>
          </v-btn>
        </template>
        Экспорт данных
      </v-tooltip>

      <v-tooltip>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            @click="importDialogShow = true"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>{{ mdiImport }}</v-icon>
          </v-btn>
        </template>
        Импорт данных
      </v-tooltip>

      <v-tooltip>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            @click="addProfileDialogShow"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>{{ mdiPlus }}</v-icon>
          </v-btn>
        </template>
        Добавить профиль
      </v-tooltip>
    </template>

    <template v-slot:content>
      <v-alert
        v-if="migrateTo"
        class="migrate-alert"
        type="error"
      >
        <p><strong>Внимание!</strong></p>
        <p>Приложение перенесено на новый <strong>постоянный</strong> адрес <strong> <a :href="migrateTo" target="_blank">{{ migrateTo }}</a></strong>.</p>
        <p>Чтобы перенести свои данные, экспортируйте (<v-btn icon @click="exportDialogShow = true"><v-icon>{{ mdiExport }}</v-icon></v-btn>) их из этого приложения и затем импортируйте в новом.</p>
        <p>Перенести данные можно до <big><strong>25.12.2022 23:59</strong></big>.</p>
      </v-alert>
      <ProfileList
        v-if="items.length"
        :items="items"
        :disabled="!!migrateTo"
        @edit="editProfile($event)"
      ></ProfileList>
      <v-layout
        v-else
        wrap
      >
        <v-flex
          xs12 lg10 offset-lg1
          class="pa-5 mt-5 text-center"
        >
          Программа <strong>Growth CP</strong> служит для контроля роста, веса и <abbr title="Индекс массы тела">ИМТ</abbr>
          для детей с <abbr title="Детским церебральным параличом">ДЦП</abbr> от 2 до 20 лет.

          Подробные сведения о программе, а также инструкции по работе с ней ниже.
        </v-flex>
        <v-flex
          xs12
          class="pa-5 mb-5 text-center"
        >
          <v-btn
            color="primary"
            @click="addProfileDialogShow"
          >Добавить профиль
          </v-btn>
        </v-flex>
      </v-layout>

      <v-divider></v-divider>

      <Help />

      <PayForm />

      <ProfileDialog
        v-model="profileDialogShow"
        :title="profileDialogTitle"
        :profile="profile"
        @close="profileDialogShow = false"
        @save="saveProfile"
        @remove="deleteProfile"
      ></ProfileDialog>
      <ExportDialog
        v-model="exportDialogShow"
        @close="exportDialogShow = false"
      ></ExportDialog>
      <ImportDialog
        v-model="importDialogShow"
        @close="importDialogShow = false"
        @import="onSuccessImport"
      ></ImportDialog>
    </template>
  </Layout>
</template>

<script>
import registryDB from '@/app/registry'
import profileDB from '@/app/profile'
import Layout from '@/components/Layout'
import Help from '@/components/Help'
import ProfileDialog from '@/components/ProfileDialog'
import ExportDialog from '@/components/ExportDialog'
import ImportDialog from '@/components/ImportDialog'
import ProfileList from '@/components/ProfileList'
import PayForm from '@/components/PayForm'

import {
  mdiPlus,
  mdiExport,
  mdiImport
} from '@mdi/js'

export default {
  components: {
    Layout,
    Help,
    ProfileDialog,
    ImportDialog,
    ExportDialog,
    ProfileList,
    PayForm
  },
  data () {
    return {
      mdiPlus,
      mdiExport,
      mdiImport,
      profileDialogShow: false,
      profileDialogTitle: '',
      importDialogShow: false,
      exportDialogShow: false,
      profile: {},
      items: []
    }
  },
  computed: {
    migrateTo () {
      return process.env.VUE_APP_MIGRATE_TO
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    onSuccessImport () {
      this.loadData().finally(() => {
        this.importDialogShow = false
      })
    },
    loadData () {
      return profileDB.getItems().then(items => {
        this.items = items
      }).catch(e => console.error(e))
    },
    initProfile (editedProfile = null) {
      let defaults = {
        name: '',
        birthdate: '',
        sex: profileDB.SEX_MALE,
        disability: 1
      }
      if (editedProfile) {
        this.profile = {
          ...defaults,
          ...editedProfile
        }
      } else {
        this.profile = Object.assign({}, defaults)
      }
    },
    addProfileDialogShow () {
      this.profileDialogShow = true
      this.profileDialogTitle = 'Добавление профиля'
      this.initProfile()
    },
    editProfile (profile) {
      this.profileDialogShow = true
      this.profileDialogTitle = 'Редактирование профиля'
      this.initProfile(profile)
    },
    saveProfile (profile) {
      let finded = false
      for (let i in this.items) {
        if (this.items[i].id === profile.id) {
          finded = true
          this.$set(this.items, i, profile)
          break
        }
      }
      if (!finded) {
        this.items.push(profile)
      }
      this.profileDialogShow = false
    },
    selectProfile (profile) {
      registryDB.set(registryDB.ACTIVE, profile.id).then(() => {
        this.$store.commit('SET_PROFILE', profile)
        this.$router.push({ name: 'home' })
      })
    },
    deleteProfile (profile) {
      for (let i in this.items) {
        if (this.items[i].id === profile.id) {
          this.items.splice(parseInt(i), 1)
          break
        }
      }
    },
    checkFields (profile, fields = []) {
      if ((!fields.length || fields.indexOf('name') >= 0)) {
        this.errorsName = []
        if (!profile.name) {
          this.errorsName.push('Не задано имя')
        }
      }
      if ((!fields.length || fields.indexOf('birthdate') >= 0)) {
        this.errorsBirthdate = []
        if (!profile.birthdate) {
          this.errorsBirthdate.push('Не задана дата рождения')
        }
      }
    }
  }
}
</script>

<style>
    .migrate-alert p {
        margin-bottom: 6px;
    }
    .migrate-alert a {
        color: white;
        text-decoration: none;
        border-bottom: 1px solid white;
    }
</style>
